import { TRecommendation } from '@/services/requests/Recommendation/types/template1';

export const getRecommendationObject = (
  data: TRecommendation | TRecommendation[],
) => {
  return (
    Array.isArray(data) && data.length > 0 ? data[0] : data
  ) as TRecommendation;
};

export const getLayoutClass = (layout = '1') => {
  return `vitrine-template1--layout-${layout}`;
};

export const getTheme = (data: TRecommendation | TRecommendation[]) => {
  const recommendation = getRecommendationObject(data);
  return recommendation.theme.replace(/[^A-Za-z]/g, '');
};

export const getThemeClass = (data: TRecommendation | TRecommendation[]) => {
  const theme = getTheme(data);
  return `vitrine-template1--theme-${theme}`;
};

export const getLayout = (data: TRecommendation) => {
  return String(data.layout) ? String(data.layout) : '1';
};

export const isLayout = (data: TRecommendation, value: string) => {
  return getLayout(data) === value;
};
